import { Component, OnInit } from '@angular/core';
import { _, StepComponent, SharedFacade, PageComponent } from '@icc/configurator/shared';
import { iccListTab, iccListItem } from '@icc/configurator/ui';
import { WindowFacade } from '../+state/window.facade';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { HandlesService } from '@icc/legacy/configurator/steps/window/handles/handles.service';

@Component({
    selector: 'icc-change-fitting-page',
    templateUrl: './change-fitting-page.component.html',
    styleUrls: ['./change-fitting-page.component.scss'],
})
export class ChangeFittingPageComponent extends PageComponent implements OnInit {
    public title = _('WINDOW|Okucie');
    public options = [];
    fittings: iccListItem[] = [];

    constructor(
        private windowFacade: WindowFacade,
        private handlesService: HandlesService,
        private sharedFacade: SharedFacade
    ) {
        super();
    }

    ngOnInit() {
        this.fittings = this.handlesService.fittings.map(fitting => ({
            id: Number(fitting.id),
            title: fitting.name,
            description: fitting.description,
            imageUrl: '/files/windowfitting/' + fitting.img,
        }));
    }

    selectFitting(item: iccListItem) {
        const fitting = this.handlesService.fittings.find(f => Number(f.id) === Number(item.id));
        if (fitting) {
            this.handlesService.selectFitting(fitting);
            this.sharedFacade.closePage();
        }
    }
}
